import { Link } from "react-router-dom";
import { films } from "@/mocks/films";
import { topics } from "@/mocks/topics";

export default function SiteIntro() {
  const stats = [
    { value: `${films.length}`, label: "精选作品" },
    { value: `${topics.length}`, label: "策划专题" },
    { value: `${films.reduce((sum, f) => sum + f.reviewsCount, 0)}`, label: "用户评论" },
    { value: "7×24", label: "内容更新" },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.18em] text-accent-600 uppercase">关于欧美伦理</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">
            在伦理故事里，看见人性的选择
          </h2>
          <p className="mt-5 text-sm md:text-[15px] leading-relaxed text-foreground-600">
            我们专注欧美伦理题材影视的整理与解读，把那些关于婚姻、家庭、法律与良知的复杂命题，拆解成清晰的剧情脉络与推荐指引。无论你是想找一部能沉下心看的作品，还是想理解一个角色的两难处境，「欧美伦理」都希望成为你可靠的入口。
          </p>
          <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-600">
            所有内容均由编辑团队筛选与撰写，坚持客观推荐、理性评论，不提供任何影视播放或下载服务。
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-3-line"></i>
              联系反馈
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {stats.map((s) => (
            <div key={s.label} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
              <p className="font-heading font-extrabold text-2xl md:text-3xl text-primary-600">{s.value}</p>
              <p className="mt-2 text-xs md:text-sm text-foreground-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}